<div class="card">

    <!-- Header -->
    <div class="flex justify-content-between align-items-center mb-4">
        <div class="flex align-items-center gap-3">
            <p-button
                icon="pi pi-arrow-left"
                [rounded]="true"
                [outlined]="true"
                severity="secondary"
                [routerLink]="['/workflow']"
                pTooltip="Voltar ao painel"
                tooltipPosition="bottom">
            </p-button>
            <h2 class="m-0">Solicitações de Aprovação</h2>
        </div>

        <div class="flex gap-2">
            <p-button icon="pi pi-refresh" label="Atualizar" [outlined]="true" severity="secondary"
                (onClick)="buscaRequisicao()"></p-button>
            <p-button severity="success" (click)="exportar()" [loading]="loadingExportacao"
                icon="pi pi-file-excel" label="Exportar"></p-button>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="carregando" class="flex justify-content-center align-items-center" style="height: 400px;">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <!-- Conteúdo Principal -->
    <div *ngIf="!carregando && requisicao" class="card p-4">

        <!-- Cabeçalho com ID e Status -->
        <div class="flex justify-content-between align-items-center mb-3">
            <h3 class="text-primary m-0">#REQ-{{ requisicao.identificador }}</h3>
            <app-tag-status [status]="requisicao.status"></app-tag-status>
        </div>

        <!-- Informações Principais em Linha -->
        <div class="flex flex-wrap gap-4 mb-3 text-600">
            <div><span class="font-semibold">Tipo:</span> {{ requisicao.entidade }}</div>
            <div><span class="font-semibold">Solicitante:</span> {{ requisicao.solicitante }}</div>
            <div><span class="font-semibold">Data:</span> {{ requisicao.criadoEm | date: 'dd/MM/yyyy HH:mm' }}</div>
            
        </div>

        <!-- Justificativa -->
        <div class="mb-4" *ngIf="requisicao.justificativa">
            <p class="m-0"><span class="font-semibold">Justificativa:</span> {{ requisicao.justificativa }}</p>
        </div>

        <!-- Itens para Aprovação -->
        <div class="mb-4">
            <div class="flex align-items-center justify-content-between mb-2">
                <div class="flex align-items-center">
                    <i class="pi pi-box mr-2"></i>
                    <span class="font-semibold">Itens para Aprovação ({{ requisicao.quantidadeItens }} Itens)</span>
                </div>
                <div class="flex gap-2" *ngIf="requisicao.status === 'PENDENTE' && isAprovador">
                    <p-button [label]="requisicao.quantidadeItens > 1 ? 'Selecionar Todos' : 'Selecionar Item'" [text]="true" size="small" (onClick)="selecionarTodos(true)"></p-button>
                    <p-button [label]="requisicao.quantidadeItens > 1 ? 'Desselecionar Todos' : 'Desselecionar Item'" [text]="true" size="small" (onClick)="selecionarTodos(false)"></p-button>
                </div>
            </div>

            <div class="border-1 border-round p-3 bg-gray-50" style="max-height: 300px; overflow-y: auto;">
                <div *ngFor="let item of requisicao.itens"
                     class="flex justify-content-between align-items-center p-3 border-bottom-1 border-gray-200 hover:bg-gray-100"
                     style="transition: background-color 0.2s;">
                    <div class="flex align-items-center gap-3 flex-1">
                        <div class="flex flex-column gap-1 w-full">
                            <span class="font-semibold">#{{ item.identificador }}</span>
                            <div class="flex flex-wrap gap-3 text-sm text-600" *ngIf="item.payloadNovo">
                                <span *ngFor="let chave of getPayloadChaves(item.payloadNovo)">
                                    <span class="font-semibold text-700">{{ formatarNomeChave(chave) }}:</span>
                                    {{ formatarValorPayload(item.payloadNovo[chave]) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex align-items-center gap-3">
                        <span class="font-semibold text-lg" *ngIf="item.payloadNovo?.vlProvisao">
                            R$ {{ item.payloadNovo.vlProvisao | number:'1.2-2' }}
                        </span>
                        <app-tag-status [status]="item.status"></app-tag-status>
                        <p-inputSwitch [(ngModel)]="item.selecionado" *ngIf="requisicao.status === 'PENDENTE' && isAprovador"></p-inputSwitch>
                    </div>
                </div>
            </div>

            <div class="mt-2 flex justify-content-between align-items-center">
                <p-button [text]="true" severity="info" (onClick)="mostrarDetalhes = !mostrarDetalhes">
                    <i [class]="mostrarDetalhes ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" class="mr-2"></i>
                    {{ mostrarDetalhes ? 'Ocultar Detalhes' : 'Mostrar Detalhes' }}
                </p-button>
                <span class="text-600" *ngIf="requisicao.status === 'PENDENTE' && isAprovador">
                    <b>{{ contarItensSelecionados() }}</b> de <b>{{ requisicao.quantidadeItens }}</b> itens selecionados
                </span>
            </div>
        </div>

        <!-- Detalhes (Colapsável) -->
        <div *ngIf="mostrarDetalhes" class="grid mb-4">

            <!-- Informações da Solicitação -->
            <div class="col-12 md:col-6">
                <h5 class="mb-3">Informações da Solicitação</h5>
                <div class="grid">
                    <div class="col-6 mb-2">
                        <div class="text-500 text-sm">ID Requisição:</div>
                        <div class="font-semibold">{{ requisicao.id }}</div>
                    </div>
                    <div class="col-6 mb-2">
                        <div class="text-500 text-sm">Workflow:</div>
                        <div class="font-semibold">{{ requisicao.workflow }}</div>
                    </div>
                    <div class="col-6 mb-2">
                        <div class="text-500 text-sm">Operação:</div>
                        <div class="font-semibold">{{ requisicao.entidade }}</div>
                    </div>
                    <div class="col-6 mb-2">
                        <div class="text-500 text-sm">Total de Itens:</div>
                        <div class="font-semibold">{{ requisicao.quantidadeItens }}</div>
                    </div>
                    <div class="col-12 mb-2" *ngIf="calcularValorTotal() > 0">
                        <div class="text-500 text-sm">Valor Total:</div>
                        <div class="font-semibold">R$ {{ calcularValorTotal() | number:'1.2-2' }}</div>
                    </div>
                </div>
            </div>

            <!-- Aprovação -->
            <div class="col-12 md:col-6">
                <h5 class="mb-3">Aprovação</h5>
                <div class="grid">
                    <div class="col-12 mb-2">
                        <div class="text-500 text-sm">Modo de Aprovação:</div>
                        <div class="font-semibold">{{ requisicao.aprovadoAutomaticamente ? 'Automático' : 'Manual' }}</div>
                    </div>
                    <div class="col-12 mb-2" *ngIf="requisicao.decididoPor">
                        <div class="text-500 text-sm">Aprovadores:</div>
                        <div class="font-semibold">{{ requisicao.decididoPor }}</div>
                    </div>
                    <div class="col-12 mb-2" *ngIf="requisicao.canceladoPor">
                        <div class="text-500 text-sm">Cancelado Por:</div>
                        <div class="font-semibold">{{ requisicao.canceladoPor }}</div>
                    </div>
                    <div class="col-12 mb-2" *ngIf="requisicao.statusIntegracao">
                        <div class="text-500 text-sm">Status Integração:</div>
                        <div class="font-semibold">
                            <app-tag-status [status]="requisicao.statusIntegracao"></app-tag-status>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Comentários -->
        <div class="mb-4" *ngIf="mostrarCampoComentarios() && requisicao.status === 'PENDENTE' && isAprovador">
            <label for="comentarios" class="block mb-2 font-semibold">Comentários da Aprovação/Rejeição:</label>
            <textarea
                id="comentarios"
                pInputTextarea
                [(ngModel)]="comentarios"
                rows="3"
                class="w-full"
                placeholder="Digite seus comentários aqui...">
            </textarea>
        </div>

        <!-- Botões de Ação -->
        <div class="flex gap-2 flex-wrap">
        
            <div class="flex gap-2" *ngIf="requisicao.status === 'PENDENTE' && isAprovador">
                <p-button [label]="getTextoBotaoPrincipal()" [icon]="getIconeBotaoPrincipal()"
                    [severity]="getSeveridadeBotaoPrincipal()" [loading]="loadingAprovacao" (onClick)="executarAcaoPrincipal()">
                </p-button>
            </div>

            <div *ngIf="requisicao.status === 'PENDENTE' && !isAprovador">
                <p-button label="Cancelar" icon="pi pi-ban" severity="secondary" [outlined]="true" [loading]="loadingAprovacao"
                    (onClick)="cancelarRequisicao()">
                </p-button>
            </div>
            
        
            <p-button icon="pi pi-arrow-left" severity="secondary" [routerLink]="['/workflow']" pTooltip="Voltar ao painel"
                tooltipPosition="bottom" label="Voltar">
            </p-button>
        </div>

    </div>

    <!-- Dialog de Confirmação -->
    <p-confirmDialog></p-confirmDialog>

    <!-- Dialog de Detalhes do Item -->
    <p-dialog [(visible)]="exibirDialogItem" [modal]="true" [style]="{width: '80vw'}" [maximizable]="true"
              header="Detalhes do Item" [draggable]="false" [resizable]="false">
        <div *ngIf="itemSelecionado">
            <!-- Informações do Item -->
            <div class="mb-4">
                <h5 class="mb-3">Informações do Item</h5>
                <div class="grid">
                    <div class="col-12 md:col-3">
                        <div class="text-500 text-sm">Identificador</div>
                        <div class="font-semibold">{{ itemSelecionado.identificador }}</div>
                    </div>
                    <div class="col-12 md:col-3">
                        <div class="text-500 text-sm">Status</div>
                        <div class="mt-1">
                            <app-tag-status [status]="itemSelecionado.status"></app-tag-status>
                        </div>
                    </div>
                    <div class="col-12 md:col-3">
                        <div class="text-500 text-sm">Status Integração</div>
                        <div class="font-semibold">{{ itemSelecionado.statusIntegracao }}</div>
                    </div>
                    <div class="col-12 md:col-3">
                        <div class="text-500 text-sm">Ordem</div>
                        <div class="font-semibold">{{ itemSelecionado.ordem }}</div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="itemSelecionado.decididoPor">
                        <div class="text-500 text-sm">Decidido Por</div>
                        <div class="font-semibold">{{ itemSelecionado.decididoPor }}</div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="itemSelecionado.dataDecisao">
                        <div class="text-500 text-sm">Data da Decisão</div>
                        <div class="font-semibold">{{ itemSelecionado.dataDecisao | date: 'dd/MM/yyyy HH:mm' }}</div>
                    </div>
                    <div class="col-12 md:col-4" *ngIf="itemSelecionado.aplicadoEm">
                        <div class="text-500 text-sm">Aplicado Em</div>
                        <div class="font-semibold">{{ itemSelecionado.aplicadoEm | date: 'dd/MM/yyyy HH:mm' }}</div>
                    </div>
                    <div class="col-12" *ngIf="itemSelecionado.comentarioDecisao">
                        <div class="text-500 text-sm">Comentário da Decisão</div>
                        <div class="font-semibold">{{ itemSelecionado.comentarioDecisao }}</div>
                    </div>
                    <div class="col-12" *ngIf="itemSelecionado.mensagemAplicado">
                        <div class="text-500 text-sm">Mensagem Aplicado</div>
                        <div class="text-red-500 font-semibold">{{ itemSelecionado.mensagemAplicado }}</div>
                    </div>
                </div>
            </div>

            <!-- Comparação de Payloads -->
            <div *ngIf="itemSelecionado.payloadOriginal || itemSelecionado.payloadNovo">
                <h5 class="mb-3">Comparação de Dados</h5>
                <p-tabView>
                    <p-tabPanel header="Payload Original" *ngIf="itemSelecionado.payloadOriginal">
                        <pre class="bg-gray-100 p-3 border-round">{{ itemSelecionado.payloadOriginal | json }}</pre>
                    </p-tabPanel>
                    <p-tabPanel header="Payload Novo" *ngIf="itemSelecionado.payloadNovo">
                        <pre class="bg-gray-100 p-3 border-round">{{ itemSelecionado.payloadNovo | json }}</pre>
                    </p-tabPanel>
                    <p-tabPanel header="Comparação" *ngIf="itemSelecionado.payloadOriginal && itemSelecionado.payloadNovo">
                        <div class="grid">
                            <div class="col-6">
                                <h6>Original</h6>
                                <pre class="bg-gray-100 p-3 border-round text-sm">{{ itemSelecionado.payloadOriginal | json }}</pre>
                            </div>
                            <div class="col-6">
                                <h6>Novo</h6>
                                <pre class="bg-green-100 p-3 border-round text-sm">{{ itemSelecionado.payloadNovo | json }}</pre>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <p-button label="Fechar" severity="secondary" (onClick)="exibirDialogItem = false"></p-button>
        </ng-template>
    </p-dialog>

</div>